import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { baseURL } from "../../../api/api";

Modal.setAppElement("#root");

const CampaignDetailsModal = ({ isOpen, onClose, screenId, MonthYear }) => {
  const [campaignsByMonth, setCampaignsByMonth] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCampaignDetails = async (screenId, monthYear) => {
    try {
      const response = await fetch(
        `${baseURL}/screens/monthlyDetails/${screenId}`,
        {
          method: "POST", // Use POST if you're sending data in the body
          headers: {
            "Content-Type": "application/json", // Specify the content type
          },
          body: JSON.stringify({ monthYear }), // Send the monthYear in the request body
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch campaign details");
      }

      const data = await response.json();
      setCampaignsByMonth(data.campaignsByDate || []); // Update this line
      setIsLoading(false);
    } catch (error) {
      setError(error.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen && screenId) {
      fetchCampaignDetails(screenId, MonthYear);
    }
  }, [isOpen, screenId]);

  const handleCloseModal = () => {
    onClose();
    setCampaignsByMonth([]);
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCloseModal}
      contentLabel="Campaign Details"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          borderRadius: "8px",
          width: "50%",
          maxHeight: "70vh",
          overflowY: "auto",
        },
      }}
    >
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold text-center">Campaign Details</h2>
        <button onClick={handleCloseModal} className="text-red-500 text-4xl">
          &times; {/* Close icon */}
        </button>
      </div>
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div>
          {campaignsByMonth.length > 0 ? (
            <table className="w-full border-collapse border border-gray-300 mb-4">
              <thead>
                <tr>
                  <th className="border border-gray-300 p-2">Date</th>
                  <th className="border border-gray-300 p-2">
                    Campaigns Names
                  </th>
                  <th className="border border-gray-300 p-2">
                    Total Campaigns
                  </th>
                </tr>
              </thead>
              <tbody>
                {campaignsByMonth.map((campaign, idx) => (
                  <tr key={idx}>
                    <td className="border border-gray-300 p-2">
                      {campaign.date}
                    </td>
                    <td className="border border-gray-300 p-2">
                      <div className="flex flex-wrap gap-2">
                        {campaign.campaigns.map((name, index) => (
                          <span
                            key={index}
                            className="bg-gray-200 text-dark p-1 rounded"
                          >
                            {name}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td className="border border-gray-300 p-2 text-center">
                      {campaign.count}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No campaign details available for this screen.</p>
          )}
        </div>
      )}
    </Modal>
  );
};

export default CampaignDetailsModal;
